import React, { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { SvgHelperWrapper } from 'src/components';
import Star from '../assets/star.svg';
import * as S from './styles';

const msgs = defineMessages({
  quote: { id: 'onboarding_upsell_quote' },
});

export const ReviewSection: FC = () => {
  const intl = useIntl();

  return (
    <S.SectionWrapper>
      <S.ReviewText>{intl.formatMessage(msgs.quote)}</S.ReviewText>

      <S.ReviewStars>
        {[...Array(5)].map((_, index) => (
          // 5 identical stars
          // eslint-disable-next-line react/no-array-index-key
          <SvgHelperWrapper Svg={Star} key={index} />
        ))}
      </S.ReviewStars>

      <S.ReviewAuthor>marceljordaan</S.ReviewAuthor>
    </S.SectionWrapper>
  );
};
